import { render, staticRenderFns } from "./LogUltimasRotinas.vue?vue&type=template&id=40271360&scoped=true"
import script from "./LogUltimasRotinas.vue?vue&type=script&lang=js"
export * from "./LogUltimasRotinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40271360",
  null
  
)

export default component.exports